import { ModelRuleCategory } from './model-rule-category';
import { ModelRuleChangeProfil } from './ModelRuleChangeProfil';
import { ModelRuleChangeModelRule } from './ModelRuleChangeModelRule';
import { IConstrainedObject } from './constraints';
import { IDescribable } from '../IDescribable';

export interface ModelRule extends IDescribable, IConstrainedObject {
  typeLvl: TypeLvl;
  typeRule: TypeRule;
  isVisible: boolean;
  modelRuleCategories: ModelRuleCategory[];
  changeProfils: ModelRuleChangeProfil[];
  changeModelRules: ModelRuleChangeModelRule[];
}

export enum TypeLvl {
  Global = 0,
  Defensive = 1,
  Offensive = 2,
  Army = 3,
}

export enum TypeRule {
  SpecialRule = 0,
  Equipment = 1,
}
